import { Injectable } from '@angular/core';

declare let Connection: any;
declare let navigator: any;

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Networking (connection connection) utility class
 */
@Injectable()
export class NetworkHelpers
{
	/**
	 * Checks if offline
	 *
	 * @returns True if it's offline, otherwise false
	 */
	public isOffLine(): boolean
	{
		return !navigator.onLine || (navigator.connection && typeof Connection !== 'undefined' && navigator.connection[Connection.NONE]);
	}

	/**
	 * Checks if online
	 *
	 * @returns True if it's offline, otherwise false
	 */
	public isOnline(): boolean
	{
		return !this.isOffLine();
	}
}


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/helpers/network-helpers.ts